import { useState } from "react";
import { useTranslation } from "react-i18next";
import SubSections from "../SubSections";

interface IServices {
  property: {
    services: [];
  }
  name?: string;
}
export const Services: React.FC<IServices> = (props) => {
  const { t } = useTranslation();
  const [isAmenities, showAmenities] = useState(false);
  const [countAmenities, updateCount] = useState(3);
  const count = props.property.services.length;
  const amenitiesOther = () => {
    return props.property.services.length - 3;
  };
  const showAllAmentities = (show: boolean, count: number) => {
    showAmenities(show);
    updateCount(count);
  };
  return (
    <SubSections
      title={props.name}
      subtitle="Free Wi-Fi  |  Pool  |  AC  |  Kitchen  |  TV"
      others="+10 0thers"
    >
      {props.property.services?.map((item, index) => (
        index < countAmenities && (
          <span key={index}>
            <span>{item}</span>
            {count > 1 && (count - 1 !== index) && <span className="other-bar"> | </span>}
          </span>
        )
      ))}
      {!isAmenities && props.property.services.length > 3 ? (
        <span className="others" onClick={() => showAllAmentities(true, 20)}>
          +{amenitiesOther()} {t('resultCard.others')}
        </span>
      ) : !isAmenities && props.property.services.length <= 3 ? (
        <></>
      ) : (
        <span className="others" style={{ marginLeft: '5px' }} onClick={() => showAllAmentities(false, 3)}>
          {t('resultCard.showLess')}
        </span>
      )}
    </SubSections>
  );
};
